export default __webpack_public_path__ + "static/media/classes_main.20ef36a6.jpeg";